import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
  selector: 'cv-configure-board-milestone',
  templateUrl: './configure-board-milestone.component.html',
  styleUrls: ['./configure-board-milestone.component.scss']
})
export class ConfigureBoardMilestoneComponent implements OnInit {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  milestoneOptions = [2, 3, 4, 5];
  oldMilestoneQty = null;
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    private cvConfigurationService: CvConfigurationService,
  ) { 
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    //Adding Milestone properties
    if (this.gs.modified.item.MilestoneDetails == undefined || this.gs.modified.item.MilestoneDetails == null) {
      this.gs.modified.item.MilestoneDetails = {
        MilestoneQty: null,
        MilestoneThemeSelected: {
          themeID: 0,
          themeName: "",
          themePath : ""
        }
      }
    }

    if (this.gs.modified.item.MilestoneDetails.MilestoneThemeSelected.themeID == 0){
      this.gs.modified.item.MilestoneDetails.MilestoneThemeSelected = this.gs.modified.item.definition.Themes[0];
    }else{
      this.gs.modified.item.MilestoneDetails.MilestoneThemeSelected = this.gs.modified.item.definition.Themes[this.gs.modified.item.MilestoneDetails.MilestoneThemeSelected.themeID - 1];
    }
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  showMilestone (index: number): boolean{
    switch (index) {
      case 0: return true;
      case 1: return (this.gs.modified.item.MilestoneDetails.MilestoneQty > 3) ? true : false;
      case 2: return (this.gs.modified.item.MilestoneDetails.MilestoneQty > 2) ? true : false;
      case 3: return (this.gs.modified.item.MilestoneDetails.MilestoneQty == 5) ? true : false;
      case 4: return true;
    }
  }
  
  setTheme (theme): void {
    this.gs.modified.item.MilestoneDetails.MilestoneThemeSelected = theme;
  }
  
  getThemeBackground () {
    return { 'background-image': 'url(' + this.gs.modified.item.MilestoneDetails.MilestoneThemeSelected.themePath + "background.svg"+')'}
  }
  
  getMilestoneImage (index: number) {
    return { 'background-image': 'url(' + this.gs.modified.item.MilestoneDetails.MilestoneThemeSelected.themePath + "check" + (index+1) + ".svg" + ')' }
  }

  checkQty(): void{
    if (this.gs.modified.item.MilestoneDetails.MilestoneQty != undefined && this.gs.modified.item.MilestoneDetails.MilestoneQty != null && this.gs.modified.item.MilestoneDetails.MilestoneQty != this.oldMilestoneQty){
      this.oldMilestoneQty = this.gs.modified.item.MilestoneDetails.MilestoneQty;
      if(this.gs.modified.item.MilestoneDetails.MilestoneQty > 1 && this.gs.modified.item.MilestoneDetails.MilestoneQty < 6){        
        var eventArgs = {
          currentStep: this.step - 1,
          unlocks: this.componentOptions.unlocks
        };

        this.componentComplete.emit(eventArgs);
      }
    }
  }

  getLocalizedMessage(key: string, value: string): string {
    return this.gamesService.getMilestoneGameMessages(key, value);
  }
}
